export default "__VITE_ASSET__Dq9xdSSR__"